<div class="modal-header">
  <h4 class="modal-title">{{ title || ("general.notice" | translate) }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <div [innerHTML]="html | safe: 'html'"></div>
  @if (prompt) {
    <br />
    <input
      type="text"
      class="form-control"
      [ngModel]="promptValue"
      (ngModelChange)="onPromptValueChange($event)"
      [placeholder]="promptPlaceholder"
      (keyup.enter)="submit()"
    />
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.dismiss('Close click')">{{ closeText }}</button>
  @if (submitFn) {
    <button type="button" class="btn btn-primary" [disabled]="prompt && !canSubmitPrompt" (click)="submit()">{{ submitText ? submitText : ("general.submit" | translate) }}</button>
  }
</div>
